import { KeyConstructor } from './keyConstructor';
const NOTIFICATIONS_KEY = 'notifications';
const NOTIFICATIONS_COUNT_KEY = 'notificationsCount';
const MEMBER_NOTIFICATION_SETTINGS = 'memberNotificationSettings';
const MEMBER_POST_NOTIFICATION_SETTINGS = 'memberPostNotificationSettings';
const SPACE_DEFAULT_NOTIFICATION_SETTINGS = 'spaceDefaultNotificationSettings';
export const getMemberNotificationSettingsKey = KeyConstructor(MEMBER_NOTIFICATION_SETTINGS);
export const getMemberPostNotificationSettingsKey = KeyConstructor(MEMBER_POST_NOTIFICATION_SETTINGS);
export const getNotificationsKey = KeyConstructor(NOTIFICATIONS_KEY);
export const getNotificationsCountKey = KeyConstructor(NOTIFICATIONS_COUNT_KEY);
export const getSpaceDefaultNotificationSettingsKey = KeyConstructor(SPACE_DEFAULT_NOTIFICATION_SETTINGS);
//# sourceMappingURL=notification.key.js.map